var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4443 11.4704V12.2592C22.4443 12.6949 22.0912 13.0481 21.6555 13.0481H12.5832V22.1204C12.5832 22.5559 12.23 22.9092 11.7943 22.9092H11.0055C10.5698 22.9092 10.2166 22.5559 10.2166 22.1204V13.0481H1.14436C0.70867 13.0481 0.355469 12.6949 0.355469 12.2592V11.4704C0.355469 11.0347 0.70867 10.6814 1.14436 10.6814H10.2166V1.60919C10.2166 1.1735 10.5698 0.820312 11.0055 0.820312H11.7943C12.23 0.820312 12.5832 1.1735 12.5832 1.60919V10.6814H21.6555C22.0912 10.6814 22.4443 11.0347 22.4443 11.4704Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.97cbd7be065e353db579a327585a4f94.svg";
export { ForwardRef as ReactComponent };